<template>
	<div>
		<div class="header" :class="{'on':scrollTop>500,'header_hidden':isHidden}">
			<div class="wrap">
				<img src="@/assets/img/logo.png"  @click="router_url('/index')" class="logo" alt="">
				<div class="nav" :class="$i18n.locale">
					<div class="li" :class="path=='xiaoxue'?'on':''" @click="router_url('/xiaoxue')">{{$t('nav_小学')}}</div>
					<div class="li" :class="path=='chuzhong'?'on':''" @click="router_url('/chuzhong')">{{$t('nav_初中')}}</div>
					<div class="li" :class="path=='guojigaozhong'?'on':''" @click="router_url('/guojigaozhong')">{{$t('nav_国际高中')}}</div>
					<div class="li" :class="path=='changchengshuyuan'?'on':''" @click="router_url('/changchengshuyuan')">{{$t('nav_长城书院')}}</div>
					<div class="li" :class="path=='laihua'?'on':''" @click="router_url('/laihua')">{{$t('nav_来华')}}</div>
				</div>
				<div class="menu_english">
					<div class="english" v-if="$i18n.locale=='en'" @click="click_lang('cn')">中文</div>
					<div class="english" v-if="$i18n.locale=='cn'" @click="click_lang('en')">English</div>
					<img src="@/assets/img/menu.png" @click="is_menu=true" class="menu" alt="">
				</div>
			</div>
		</div>
		<div class="header_fixed" v-if="is_menu">
			<div class="wrap">
				<img src="@/assets/img/bai_logo.png"  @click="router_url('/index')" class="logo" alt="">
				<div class="language">
					<div class="li" :class="$i18n.locale=='cn'?'on':''" @click="click_lang('cn')">中文</div>
					<div class="li" :class="$i18n.locale=='en'?'on':''" @click="click_lang('en')">English</div>
				</div>
				<img src="@/assets/img/menu_close.png" @click="is_menu=false" class="close" alt="">
			</div>
			<div class="list">
				<vue-scroll>
					<div class="wrap">
						<div class="list_li">
							<div class="name" @click="click_router_url('/tansuo')">{{$t('探索')}} <i :class="'el-icon-arrow-'+(on==1?'up':'down')" @click.stop="on=on==1?'':1"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==1">
									<div class="li" @click="click_router_url('/tansuo?elementId=womendeyuanjing')">{{$t('我们的愿景')}}</div>
									<div class="li" @click="click_router_url('/tansuo?elementId=womendelishi')">{{$t('我们的历史')}}</div>
									<div class="li" @click="click_router_url('/tansuo?elementId=VRtanxiao')">{{$t('VR探校')}}</div>
									<div class="li" @click="click_router_url('/tansuo?elementId=xiaoyuansheshishebei')">{{$t('校园设施设备')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/zhaosheng')">{{$t('招生')}} <i :class="'el-icon-arrow-'+(on==2?'up':'down')" @click.stop="on=on==2?'':2"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==2">
									<div class="li" @click="click_router_url('/zhaosheng?elementId=yuyuetanxiao')">{{$t('预约探校')}}</div>
									<div class="li" @click="click_router_url('/zhaosheng?elementId=xuexiaoshoufeibiaozhun')">{{$t('学校收费标准')}}</div>
									<div class="li" @click="click_router_url('/zhaosheng?elementId=tuifeizhengce')">{{$t('退费政策')}}</div>
									<div class="li" @click="click_router_url('/zhaosheng?elementId=qa')">{{$t('招生问答')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/xiaoxue')">{{$t('小学')}} <i :class="'el-icon-arrow-'+(on==8?'up':'down')" @click.stop="on=on==8?'':8"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==8">
									<div class="li" @click="click_router_url('/xiaoxue?elementId=hexinkecheng')">{{$t('核心课程')}}</div>
									<div class="li" @click="click_router_url('/xiaoxue?elementId=ronghekecheng')">{{$t('IB-PBL融合课程')}}</div>
									<div class="li" @click="click_router_url('/xiaoxue?elementId=suzhituozhantixi')">{{$t('素质拓展体系')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/chuzhong')">{{$t('初中')}} <i :class="'el-icon-arrow-'+(on==9?'up':'down')" @click.stop="on=on==9?'':9"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==9">
									<div class="li" @click="click_router_url('/chuzhong?elementId=xingzoudeketang')">{{$t('行走的课堂')}}</div>
									<div class="li" @click="click_router_url('/chuzhong?elementId=duoyuanshengxuetongdao')">{{$t('多元升学通道')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/guojigaozhong')">{{$t('国际高中')}} <i :class="'el-icon-arrow-'+(on==10?'up':'down')" @click.stop="on=on==10?'':10"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==10">
									<div class="li" @click="click_router_url('/guojigaozhong?elementId=huangjinshizipeizhi')">{{$t('黄金师资配置')}}</div>
									<div class="li" @click="click_router_url('/guojigaozhong?elementId=guojiban')">{{$t('IP国际班')}}</div>
									<div class="li" @click="click_router_url('/guojigaozhong?elementId=shengxuebaogao')">{{$t('升学报告')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/changchengshuyuan')">{{$t('长城书院')}} <i :class="'el-icon-arrow-'+(on==11?'up':'down')" @click.stop="on=on==11?'':11"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==11">
									<div class="li" @click="click_router_url('/changchengshuyuan?elementId=guonakecheng')">{{$t('国内课程')}}</div>
									<div class="li" @click="click_router_url('/changchengshuyuan?elementId=shuangguihuzhuan')">{{$t('双轨互转')}}</div>
									<div class="li" @click="click_router_url('/changchengshuyuan?elementId=shuangyufunenjihua')">{{$t('双语赋能计划')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/laihua')">{{$t('来华')}} <i :class="'el-icon-arrow-'+(on==12?'up':'down')" @click.stop="on=on==12?'':12"></i></div>
							<el-collapse-transition>
								<div class="ul" v-if="on==12">
									<div class="li" @click="click_router_url('/laihua?elementId=zizhiyubaozhang')">{{$t('资质与保障')}}</div>
									<div class="li" @click="click_router_url('/laihua?elementId=zhongwenyuxueshu')">{{$t('中文与学术')}}</div>
									<div class="li" @click="click_router_url('/laihua?elementId=chenggonganli')">{{$t('成功案例')}}</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="list_li">
							<div class="name" @click="click_router_url('/news_info')">{{$t('新闻')}} <i :class="'el-icon-arrow-'+(on==14?'up':'down')"></i></div>
						</div>
					</div>
				</vue-scroll>
			</div>
		</div>
		<div class="english_tanchu" v-if="is_english">
			<div class="center">
				<i class="el-icon-error guanbi" @click="is_english=false"></i>
				<img src="@/assets/img/english_tanchu.png" class="img" alt="">
				<div class="name">Website construction in progress</div>
			</div>
		</div>
	</div>
</template>
<script>
const config = require('@/../vue.config');
export default {
	name: 'header_html',
	data(){
		return{
			scrollTop:0,
			is_menu:false,
			isHidden:false,
			path:'',
			on:0,
			is_english:false,
			lang:'',
		}
	},
	mounted(){
		this.lang = localStorage.getItem('lang')||'cn';
		this.path = this.$route.path.replace('/', '');
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods:{
		handleScroll(e){
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			scrollTop = scrollTop<0?0:scrollTop;
			if(scrollTop>this.scrollTop){
				this.isHidden = true;
			}else{
				this.isHidden = false;
			}
			this.scrollTop = scrollTop;
		},
		click_router_url(url){
			this.is_menu = false;
			console.log(1)
			this.router_url(url);
		},
		click_lang(name){
			if (this.lang!=name) {
				localStorage.setItem('lang',name);
				this.$i18n.locale = this.lang = name;
				if(name=='cn'){
					document.title = config.API_TITLE;
				}else{
					document.title = config.API_TITLE_EN;
				}
			}
		}
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/header.vue